<template>
  <div class="ks-login-container" :class="{'handheld-device': is_ios_safari || is_android, 'ios-safari': is_ios_safari, 'android': is_android }">
      <div class="login ks-floating-menu" v-if="show_login">
        
        <div class="login-header">
          <div class="login-title">Kepit</div>
        </div>
        
        <div class="login-body">
          <div class="field username">
            <label class="label">Username</label>
            <input class="ks-input-field" type="text" v-model="loginForm.email" @keyup.enter="login" :disabled="maintenance">
          </div>
          <div class="field password">
            <label class="label">Password</label>
            <input class="ks-input-field" type="password" v-model="loginForm.password" @keyup.enter="login" :disabled="maintenance">
          </div>
          <div class="bottom-row">
            <div class="message">{{ message }}</div>
            <button class="login-button ks-btn" v-on:click="login" :disabled="maintenance">Login</button>
          </div>
        </div>
      </div>    
  </div>
</template>

<script>
import moment from 'moment'
export default {
  data () {
    return {
      loginForm: {
        email: "",
        password: ""
      },
      message: "",
      showError: false,
      show_login: true
    }
  },
  methods: {
    login () {
      this.$store.dispatch("log_in", this.loginForm).then(() => {
        this.$router.push(this.$route.query.redirect||"/")
        this.loginForm.email = ""
        this.loginForm.password = ""
      },
      (error) => {
        this.loginForm.password = ""
        console.log(error);
        this.message = error.msg
        this.showError = true
      });
    }
  },
  computed: {
    maintenance() {
      return this.$store.state.maintenance.running && this.$store.state.maintenance.info.start_time <= moment().unix();
    },
    is_ios_safari: function() {
            var ua = window.navigator.userAgent;
            var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
            var webkit = !!ua.match(/WebKit/i);
            var iOSSafari = iOS && webkit && !ua.match(/CriOS/i);
            console.log("is_ios_safari", iOSSafari);
            return iOSSafari;
    },
    is_android: function() {
            return /android/i.test(navigator.userAgent);
    },
  },
  created() {
    if(this.$route.query.l == "1") {
      this.$router.push("/login");
      this.$nextTick(() => {
        location.reload();
      })
    }
  }
}
</script>

<style scoped>
      .ks-login-container {
        overflow: hidden;
        background: var(--ks-background-color-dark);
        color: var(--ks-font-color-primary);
        width: 100%;
        height: 100%;
        --spacing-size: 32px;
        --login-button-width: 104px;
        --kepit-logo-size: 56px;
        --title-font-size: 24px;
      }
      .ks-login-container::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        -webkit-mask-image: url(/Kepit_logo_pattern_MASK_CRPO.svg);
        mask-image: url(/Kepit_logo_pattern_MASK_CRPO.svg);
        -webkit-mask-size: cover;
        mask-size: cover;
        background-color: var(--ks-background-color);
      }

      .ks-login-container.handheld-device {
        --spacing-size: 64px;
        --login-button-width: 208px;
        --kepit-logo-size: 112px;
        --title-font-size: 48px;

        .field .label,
        .field input,
        .bottom-row .login-button {
          font-size: 32px;
        }
        .field input {
          height: 64px;
        }
        .bottom-row .login-button {
          height: 64px;
        }
        .bottom-row .message {
          font-size: 24px;
        }
      }

      .login .login-header::before {
        content: "";
        position: relative;
        display: flex;
        height: var(--kepit-logo-size);
        width: var(--kepit-logo-size);
        background: url(/kepit_emblem.svg) center / contain no-repeat;
      }

      .login {
         width: calc(100% - var(--spacing-size)*2);
      }

      @media (orientation: landscape) {
        .login {
          max-width: 500px;
        }
      }

      .login {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        height: max-content;

        display: grid;
        grid-template-rows: max-content max-content;

        padding: var(--spacing-size);
        margin: 0;

        box-sizing: border-box;

        .login-header {
          display: flex;
          align-items: center;
          gap: var(--spacing-size);
          padding-bottom: var(--spacing-size);

          .login-title {
            font-size: var(--title-font-size);
            line-height: var(--title-font-size);
          }
        }

        .login-body {
          display: flex;
          flex-direction: column;
          gap: var(--spacing-size);

          .field {
            display: flex;
            flex-direction: column;

            .label {
              color: var(--ks-font-color-accent);
            }
          }
          .bottom-row {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: var(--spacing-size);
          }
          .login-button {
            width: var(--login-button-width);
          }
        }
      }

      .login .field:has(input:focus) .label {
        color: var(--ks-col-accent);
      }

      .login .login-body .message {
        color: var(--ks-col-danger-light);
      }

</style>
